import { createAction } from '@ngrx/store';

export const NavigateToUsers = createAction(
  '[Router] Navigate To Users'
);

export const NavigateToUsersSuccess = createAction(
  '[Router] Navigate To Users Success'
);
